import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CGPAValidationUtils {

    static cgpaValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;

            if (value === null || value === undefined || value === '') {
                return null;
            }

            if (isNaN(value)) {
                return { invalidCgpa: true };
            }

            const num = Number(value);

            if (num < 0 || num > 10) {
                return { cgpaRange: true };
            }

            if (!/^\d+(\.\d{1,2})?$/.test(value.toString())) {
                return { invalidCgpa: true };
            }

            return null;
        };
    }

    static getCgpaError(control: AbstractControl | null): string {

        if (!control || !control.errors || !control.touched) {
            return '';
        }

        if (control.errors['invalidCgpa']) {
            return 'Please enter a valid CGPA.';
        }

        if (control.errors['cgpaRange']) {
            return 'CGPA must be between 0 and 10.';
        }

        return '';
    }
}